export default __webpack_public_path__ + "static/media/bids3.c22ef57b.png";